import { roles } from "shared/constants/Constants.js";

const fleetManagementRoutes = {
  dashboard: [
    {
      path: "maintenance_workshop_bill",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ws-bill" */
          "../../feature/fleet-management/dashboard/WSBill.js"
        ),
      authorized: [roles.FLEET_EXECUTIVE, roles.WORKSHOP_PARTNER],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "WS Agent Bill",
    },
    {
      path: "maintenance_review_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "review-list" */
          "../../feature/fleet-management/dashboard/ReviewList.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "Review List",
      countKey: "maintenance_pending_review_count",
    },
    {
      path: "maintenance_escalations",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "maintenance-escalations" */
          "../../feature/fleet-management/dashboard/ReviewList.js"
        ),
      authorized: [roles.DRIVER_MANAGER],
      sidebarGroup: "driverList",
      sidebarLabel: "Escalations",
    },
    {
      path: "maintenance_workshop_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "ws-list" */
          "../../feature/fleet-management/dashboard/WSList.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
        roles.HUB_MANAGER,
      ],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "W/S List",
      countKey: "maintenance_pending_workshopList_count",
    },
    {
      path: "bill_upload_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "bill-upload-list" */
          "../../feature/fleet-management/dashboard/BillUploadList.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.FINANCE,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
        roles.FLEET_EXECUTIVE,
      ],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "Bill Upload",
      countKey: "bill_upload_count",
    },
    {
      path: "maintenance_dashboard",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "maintenance-dashboard" */
          "../../feature/fleet-management/dashboard/DashboardList.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "Dashboard",
    },

    {
      path: "maintenance_mapping",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "maintenance-mapping" */
          "../../feature/fleet-management/dashboard/MappingList.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.HUB_MANAGER,
        roles.FLEET_GENERAL_MANAGER,
        roles.FLEET_MANAGER,
      ],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "Mapping",
    },
    {
      path: "insurance_rejected",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "insurance-rejected" */
          "../../feature/fleet-management/dashboard/InsuranceRejected.js"
        ),
      authorized: [roles.ADMIN, roles.FLEET_GENERAL_MANAGER],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "Insurance Rejected",
      countKey: "maintenance_pending_insurance_rejected_count",
    },
    {
      path: "eta_change",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "eta-change" */
          "../../feature/fleet-management/dashboard/EtaChange.js"
        ),
      authorized: [roles.FLEET_GENERAL_MANAGER, roles.ADMIN],
      sidebarGroup: "maintenanceList",
      sidebarLabel: "ETA Change",
      countKey: "maintenance_pending_eta_change_count",
    },
    {
      path: "dp_ready_assign",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "dp-ready-assign" */
          "./pages/DpReadyAssign.js"
        ),
      authorized: [roles.DRIVER_MANAGER, roles.HUB_MANAGER, roles.SENIOR_DRIVER_MANAGER],
      sidebarGroup: "requestList",
      sidebarLabel: "WS Ready Assign",
    },
    {
      path: "dp_drop_swap",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "dp-drop-swap" */
          "./pages/DpDropSwap.js"
        ),
      authorized: [roles.DRIVER_MANAGER, roles.HUB_MANAGER, roles.SENIOR_DRIVER_MANAGER],
      sidebarGroup: "requestList",
      sidebarLabel: "WS Drop/Swap",
    },
  ],
  standalone: [
    {
      path: "/fleet/vehicleAssignById/:request_id/:type",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-main-screen" */
          "./fleet-management-screen/recovery/RecoveryMainScreen.js"
        ),
      protected: true,
    },
    {
      path: "/fleet/request/:id/:type",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-main-screen" */
          "./fleet-management-screen/recovery/RecoveryMainScreen.js"
        ),
      protected: true,
    },
    {
      path: "/management/recovery/get/:fleetID/:sidebarListClick",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "recovery-main-screen" */
          "./fleet-management-screen/recovery/RecoveryMainScreen.js"
        ),
      protected: true,
    },
  ],
};

export default fleetManagementRoutes;
